import { jsxs as r, jsx as l } from "react/jsx-runtime";
const t = (o) => /* @__PURE__ */ r(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    ...o,
    children: [
      /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M4.728 14V6.714L3.016 5.012 3 1h10v4.012L11.273 6.73v6.173l-1.5-.402L9.37 14H4.726ZM11.5 3.494V2.5H4.506l.004.994h6.99ZM9.773 12.5V6.105l.442-.44.675-.671H5.124l.66.656.442.44v6.41h3.547Z"
        }
      ),
      /* @__PURE__ */ l("path", { fill: "currentColor", d: "M7 10V8h2v2H7Z" })
    ]
  }
);
export {
  t as Torch
};
